export default function assert(condition,message){if(!condition)throw new Error(message||"react-map-gl: assertion failed.")}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/utils/assert.js
// module id = 174
// module chunks = 0